import { schoolSelectionActionTypes as act } from './actionTypes';

export default function schoolSelection(
  state = {
    selectedSchool: null,
  },
  { payload, type }
) {
  switch (type) {
    case act.SELECT_SCHOOL: {
      const { selectedSchool } = payload;
      return {
        ...state,
        selectedSchool,
      };
    }
    case act.RESET_SCHOOL_SELECTION: {
      return {
        ...state,
        selectedSchool: null,
      };
    }
    default:
      return state;
  }
}
